<template>
  
    <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content" name="popUpPresaInCarico" @before-open = "getIntervento">
      
        <div class="BtnClose">
          <span style="cursor:pointer"><mdi-close @click="this.closeModal()" ></mdi-close></span>
        </div>
        <div class="PopUpBox">
        <div class="PopUpTitle Iconed AddNote">Aggiungi nota di presa in carico</div>
        <div class="PopUpContent">
            <form class="Form">
                <fieldset>
                    <div class="FormRow">
                        <div class="FormBoxWide">
                            <label>Data Prevista Effettuazione</label>
                            <input type="date" id="" v-model="this.dataEffettuaz"/>
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBoxWide">
                            <label>Note:</label>
                            <textarea v-model="this.notePresaInCarico"></textarea>
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBoxWide">
                            <div class="TwinButtons">
                            <div class="Button  ExtraSmall"><input type="button"  value="Salva nota" @click="this.salvaNota"></div>
                            <div class="Button  ExtraSmall"><input type="button"  value="Annulla"></div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </form>
        </div>
        <div class="PopUpFooter">
            <form>
            <div class="Button CustomColor2"><input type="button" @click="this.confermaPresaInCarico"  value="Conferma presa in carico"></div>
            </form>    
        </div>
    </div>
    </vue-final-modal>
  
</template>
<script>


import MdiClose from "@/components/modals/MdiClose.vue";
import Intervento from "@/models/intervento.model.js";
import {apiMixin, dateMixin} from "/mixin.js";

export default {
    name: "PresaInCaricoModal",    
    props:{
      showModal: Boolean,
      response: Number,
      chiaveIntervento: String
    },
    components:{
      MdiClose
    },
    data(){
      return {
        notePresaInCarico: "",
        dataEffettuaz: ""
      }
    },
    mixins: [apiMixin, dateMixin],
    methods:{
      closeModal: function(){
        this.$vfm.hide('popUpPresaInCarico') 
      },
      salvaNota: function(){
          let postBody = {
            "SysChiaveglobale" : this.chiaveIntervento,
            "Note" : this.notePresaInCarico,
            "DataEffettuazione" : this.dataEffettuaz
          };
          
          this.doApiCall("post", "interventi/SetNotePresaInCarico", this.$store.getters.getUtente.Token, null, postBody).then(

            (data) => {             
              if(data.StatusCode === 200){
                  this.$toast.success("Dati salvati con successo!", {position:"top-right"});
              }
              else{
                this.$toast.error("Attenzione! Si sono verificati errori durante il salvataggio dei Dati!", {position:"top-right"});
              }
            }
        );
      },
      confermaPresaInCarico: function(){
          let postBody = {
            "SysChiaveglobale" : this.chiaveIntervento
          };
          this.$parent.showGridAttivita = false;
          this.doApiCall("post", "interventi/FirmaPresaInCarico", this.$store.getters.getUtente.Token, null, postBody).then(
            (data) => {             
              if(data.StatusCode === 200){
                  this.$toast.success("Presa in carico avvenuta con successo!", {position:"top-right"});
                  let nuoviInterventi = this.$parent.$parent.$parent.listaInterventi.filter(item => {return item.SysChiaveglobale !== data.Data});
                  this.$parent.$parent.$parent.listaInterventi = nuoviInterventi;
                  this.$parent.$parent.$parent.$parent.$refs.QuickLinks.numInterventiInCarico += 1; 
                  this.$vfm.hide('popUpPresaInCarico') 
              }
              else{
                this.$toast.error("Attenzione! Si sono verificati errori durante la presa in carico dell'intervento! Errore: "+data.Message, {position:"top-right"});
              }
            }
        );
      },
      getIntervento: function(){
        let keys = this.chiaveIntervento.split('~|~');
        let postBody = {
          "CodiceIntervento": keys[1] 
        }
        this.doApiCall("get", "interventi/GetDettaglioIntervento", this.$store.getters.getUtente.Token,postBody).then(
            (data) => {               
                if(data){
                  Object.assign(new Intervento(), data);
                  this.notePresaInCarico = data.NotePresaInCarico;
                  this.dataEffettuaz = this.formatDateNoOreJQuery(data.DataEffettuazione);                 
                }
            }
        );
      } 
    }

}
</script>
<style>

.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 600px;  
}

.BtnClose{ 
  text-align: right;
}

.modal__close { 
  background: none;
}
</style>

